@for (child of node?.children; track child.uid) {
  <ng-container *ngTemplateOutlet="nav; context: { node: child, depth: 0 }"></ng-container>
}

<!-- we generate links in a recursive manner -->
<ng-template #nav let-node="node" let-depth="depth">
  @if (
    !(node.uid === 'StripNarrowNavNode' && !stripNarrowAvailable) &&
    (node.uid !== 'CampaignNavNode' || node.url) &&
    (node.uid !== 'CampaignsNavNode' || node.url) &&
    (node.uid !== 'FavoritesNavNode' || node.url) &&
    (node.uid !== 'MostPurchasedNavNode' || node.url) &&
    (node.uid !== 'BaseOrdersNavNode' || node.url)
    ) {
    <nav
      #menu
      class="{{ node.uid }}"
      [attr.aria-expanded]="isOpened"
      [attr.aria-controls]="'navigation-wrapper-' + node.uid"
      [ngClass]="isActivePage(node.url) ? 'active' : ''"
      (click)="toggleOpen($event)"
      (keydown.space)="toggleOpen($event)"
      (keydown.esc)="back()"
      >
      @if (node.url && (!node.children || node.children?.length === 0)) {
        <aimo-cx-generic-link
          [url]="node.url"
          [target]="node.target"
          [style]="node.styleAttributes"
          [class]="node.styleClasses?.includes('aimo-icon') ? '' : node.styleClasses"
          [title]="node.title"
          (click)="closeIfClickedTheSameLink(node)">
          @if (node.styleClasses?.includes('aimo-icon')) {
            <i class="{{ node.styleClasses }}"></i>
          }
          <span class="d-inline" id="nav-{{ node.uid }}">{{ node.title }}</span>
        </aimo-cx-generic-link>
      } @else {
        @if (node.uid && node.uid === 'MyAccountNavNode') {
          <div
            role="button"
            [attr.aria-label]="node.title"
            [attr.tabindex]="flyout && (depth === 0 || node.url) ? 0 : -1">
            <i class="aimo-icon icon-sm icon-white icon-user mr-2 d-lg-inline-block d-none"></i>
            <i class="aimo-icon icon-petrol-blue icon-user mr-2 d-inline-block d-lg-none"></i>
            @if (customerName$ | async; as customerName) {
              @if (customerId$ | async; as customerId) {
                <span id="account-{{ customerId }}">
                  @if (customerNameShort$ | async; as customerNameShort) {
                    @if (showMyAssortment$ | async; as showMyAssortment) {
                      <span class="d-none d-lg-inline d-xl-inline">{{ customerNameShort }}</span>
                      <span class="d-inline d-lg-none d-xl-none">{{ customerName }}</span>
                    } @else {
                      {{ customerName }}
                    }
                  }
                </span>
                @if (pendingApprovals$ | async; as pendingApprovals) {
                  @if (pendingApprovals > 0) {
                    <span
                      class="quantity circle circle-sm bg-red text-white text-xsm text-bold ml-1"
                      >
                      {{ pendingApprovals }}
                    </span>
                  }
                }
              }
            }
            <i
            class="aimo-icon icon-inline icon-sm icon-white icon-caret-down ml-2 d-lg-inline-block d-none"></i>
            <i class="aimo-icon icon-inline icon-petrol-blue icon-caret-down ml-2 d-inline-block d-lg-none"></i>
          </div>
        } @else {
          <div class="heading-wrapper">
            <h4
              [attr.aria-label]="node.title"
              class="text-lg"
              [attr.tabindex]="flyout && (depth === 0 || node.url) ? 0 : -1">
              {{ node.title }}
              <cx-icon [type]="iconType.CARET_RIGHT"></cx-icon>
            </h4>
          </div>
        }
      }
      <!-- we add a wrapper to allow for better layout handling in CSS -->
      @if (node.children?.length > 0) {
        <div class="wrapper" id="navigation-wrapper-{{ node.uid }}">
          <div
            class="childs"
            [attr.depth]="getTotalDepth(node)"
            [attr.wrap-after]="node.children?.length > wrapAfter ? wrapAfter : null"
            [attr.columns]="getColumnCount(node.children?.length)">
            @for (child of node.children; track child.uid) {
              @if (child.url) {
                <ng-container
                *ngTemplateOutlet="nav; context: { node: child, depth: depth + 1 }"></ng-container>
              }
            }
          </div>
        </div>
      }
    </nav>
  }
</ng-template>
